import React, { FC } from 'react';

import { AnalyticsProfile, GetEmployeesQueryVariables, OrganicInsightsSortParam } from 'api';
import { InfiniteQuery } from 'types/app';
import { useCheckedState } from 'hooks';
import { EmptyState } from 'components';

import EmployeeTable from './EmployeeTable';

interface Props {
  variables: GetEmployeesQueryVariables;
  setVariables: (variables: GetEmployeesQueryVariables) => void;
  queryOptions: InfiniteQuery<AnalyticsProfile>;
}

const IdentifiedTab: FC<Props> = ({ variables, setVariables, queryOptions }) => {
  const checkedOptions = useCheckedState();

  function updateTableColumnSort(param: OrganicInsightsSortParam) {
    setVariables({
      ...variables,
      sort_by: param[0],
    });
  }

  if (queryOptions.isEmpty) {
    return <EmptyState name="insightsEmployee" />;
  }

  return (
    <EmployeeTable
      onSort={updateTableColumnSort}
      sortBy={variables.sort_by}
      {...checkedOptions}
      {...queryOptions}
    />
  );
};

export default IdentifiedTab;
